import { render, staticRenderFns } from "./ProjectCarousel.vue?vue&type=template&id=75aa9978&scoped=true&"
import script from "./ProjectCarousel.vue?vue&type=script&lang=js&"
export * from "./ProjectCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ProjectCarousel.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ProjectCarousel.vue?vue&type=style&index=1&id=75aa9978&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75aa9978",
  null
  
)

export default component.exports